import {
  BackDropComp,
  FormattedText,
  H5Tag,
  ImageComponent,
  ReactPortalComp,
  TextNodeType,
  ParaTag,
} from "@tm/ui-widgets/components";
import React, { useEffect } from "react";
import {
  CommonModalDwebStyle,
  CommonModalHeader,
  CrossIconWrap,
} from "./RegionModalDweb.style";

interface ModalInterface {
  children?: React.ReactNode;
  customTitle?: string | TextNodeType;
  handleClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  customWidth?: string;
  nonClipHeading?: boolean;
}

const RegionModalDweb = ({
  children,
  customTitle,
  handleClick,
  customWidth,
  nonClipHeading,
}: ModalInterface) => {
  useEffect(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? (parentElement.style.overflow = "unset") : "";
    return () => {
      parentElement ? (parentElement.style.overflowY = "scroll") : "";
    };
  }, []);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <ReactPortalComp>
      <CommonModalDwebStyle customWidth={customWidth}>
        <CommonModalHeader nonClipHeading={nonClipHeading}>
          <div>
            <H5Tag>
              <ImageComponent
                width="28px"
                height="28px"
                src="https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg"
              />
              <CrossIconWrap onClick={handleClick}>
                <ImageComponent
                  width="28px"
                  height="28px"
                  src="https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
                />
              </CrossIconWrap>
            </H5Tag>
            <ParaTag fontSize="xlarge" fontWeight="black">
              <FormattedText value={customTitle} />
            </ParaTag>
          </div>
          {/* {customSubTitle && <FormattedText value={customSubTitle} />}x */}
        </CommonModalHeader>
        {children}
      </CommonModalDwebStyle>
      <BackDropComp onClose={handleClick} />
    </ReactPortalComp>
  );
};

export default RegionModalDweb;
